import { Paper } from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { isNumericGuard } from "utils/dataManipulation";

import { LoadingOrEmptyWrapper } from "../LoadingAndEmptyHandler";
import { NavigationTabs } from "../NavigationTabs";
import { Asset3DViewer } from "./Asset3DViewer";
import { AssetImages, AssetImagesProps } from "./AssetImages";
import { AssetInfo } from "./AssetInfo";
import { AssetMiniMap } from "./AssetMiniMap";
import { Config } from "./types";

type AssetDetailedCardProps = AssetImagesProps & {
  className?: string;
  config: Config;
  isLoading?: boolean;
  name?: string;
  onClick?: () => void;
};

export const AssetDetailedCard = ({
  building,
  buildingType,
  className,
  config,
  imageClassName,
  imgPath,
  isLoading,
  name,
  onClick,
  upload = true,
}: AssetDetailedCardProps) => {
  const { t } = useTranslation();
  const tabs = [
    {
      displayName: t("BuildingProfile.detailsCard.nav.image"),
      name: "image",
    },
    {
      displayName: t("BuildingProfile.detailsCard.nav.miniMap"),
      name: "miniMap",
    },
    {
      displayName: t("BuildingProfile.detailsCard.nav.threeDModel"),
      name: "3DModel",
    },
  ];
  const [activeTab, setActiveTab] = useState<{ displayName?: string; name: string }>(tabs[0]);

  if (!building) return null;

  const latitude = building.latitude;
  const longitude = building.longitude;
  const hasCoordinates = isNumericGuard(latitude) && isNumericGuard(longitude);

  return (
    <LoadingOrEmptyWrapper height="100%" showLoading={isLoading}>
      <Paper className={className} onClick={onClick}>
        <NavigationTabs activeTab={activeTab} className="mb-4" setActiveTab={setActiveTab} tabs={tabs} />
        {activeTab.name === tabs[0].name && (
          <AssetImages
            building={building}
            buildingType={buildingType}
            imageClassName={imageClassName}
            imgPath={imgPath}
            upload={upload}
          />
        )}
        {activeTab.name === tabs[1].name && hasCoordinates && (
          <AssetMiniMap latitude={latitude} longitude={longitude} />
        )}
        {activeTab.name === tabs[2].name && <Asset3DViewer buildingId={building?.id} />}
        <AssetInfo building={building} config={config} name={name} />
      </Paper>
    </LoadingOrEmptyWrapper>
  );
};
